import React, { useState } from 'react'

import Info from 'public/assets/svg/info.svg'
import { motion } from 'framer-motion'

import injectSheet from 'react-jss'
import compose from 'recompose/compose'

import ShareMenuContainer from '../../containers/ShareMenu'
import styles from './styles'
import { sanitize } from 'dompurify'

export const getAwsVideoUrl = selectedVideo => {
    return `https://video${selectedVideo.url.split('video')[1]}`
}

export const getVimeoVideoUrl = selectedVideo => {
    return `https://player.vimeo.com/video/${selectedVideo.videoid}?embedparameter=value`
}

export const getYoutubeVideoUrl = selectedVideo => {
    return `https://www.youtube-nocookie.com/embed/${selectedVideo.videoid}?controls=true&amp;showinfo=0&amp;wmode=transparent&amp;loop=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fyouvisit.com&amp;widgetid=3&amp;modestbranding=1`
}

const Videoviewer = props => {
    const [info, showInfo] = useState(false)

    const { media, selectedIdx, inst_id, loc_id, classes } = props
    const { type, id } = media[selectedIdx]

    const shareUrl = `${process.env.REACT_APP_BASE_URL}/tour/videos/${inst_id}/${loc_id}?id=${id}`

    const animations = {
        open: {
            x: '0%',
            transition: {
                ease: [0.28, 0.57, 0.2, 1],
                duration: 0.5,
            },
        },
        closed: {
            x: '100%',
            transition: {
                ease: 'easeIn',
                duration: 0.25,
            },
        },
    }

    const getVideo = videoType => {
        let url
        switch (videoType) {
            case 'aws':
                url = getAwsVideoUrl(media[selectedIdx])
                // eslint-disable-next-line jsx-a11y/media-has-caption
                return <video className={classes.awsVideo} controls src={url} />
            case 'vimeo':
                url = getVimeoVideoUrl(media[selectedIdx])
                return <iframe src={url} title="Video Player" frameBorder="0" />
            case 'youtube':
                url = getYoutubeVideoUrl(media[selectedIdx])
                return (
                    <iframe
                        id="video_2"
                        className="video-player"
                        frameBorder="0"
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        title="YouTube video player"
                        width={`${info ? '1009' : '1056'}px`}
                        height="683px"
                        src={url}
                        data-testid="video"
                    />
                )
            default:
                return <div>Video Type Not Found</div>
        }
    }

    return (
        <>
            <div className={classes.videoContainer} data-testid="video">
                {getVideo(type)}
                <div className={classes.infoPanel}>
                    {!info && (
                        <div className={classes.title} data-testid="title">
                            {media[selectedIdx].title}
                        </div>
                    )}
                    <motion.div
                        initial={{ x: '100%' }}
                        animate={info ? 'open' : 'closed'}
                        variants={animations}
                        className={classes.infoPanel}
                    >
                        <div
                            className={classes.description}
                            data-testid="description"
                            dangerouslySetInnerHTML={{
                                __html: sanitize(media[selectedIdx].description, { ADD_ATTR: ['target'] }),
                            }}
                        ></div>
                        )
                    </motion.div>
                </div>
                {shareUrl && (
                    <div className={classes.shareMenu}>
                        {!info && (
                            <span
                                style={{
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    bottom: '0%',
                                    right: '0%',
                                }}
                            >
                                <ShareMenuContainer url={shareUrl} className={classes.shareMenu} svgColor="#FFFFFF" />
                            </span>
                        )}
                    </div>
                )}
            </div>
            {media[selectedIdx].description && (
                <div
                    className={classes.info}
                    onClick={() => showInfo(!info)}
                    onKeyDown={() => showInfo(!info)}
                    role="button"
                    tabIndex={0}
                    data-testid="info"
                >
                    <img src={Info} />
                </div>
            )}
        </>
    )
}

export default compose(injectSheet(styles))(Videoviewer)
